import styled from '@emotion/styled';
import { Flex } from 'antd';

import { Button } from 'ui/base';

export const Wrapper = styled.div`
  overflow: hidden;
  border-radius: 3px;
  background-color: #fff;
  border-radius: 2px;
  height: auto;
  width: auto;
  box-shadow: 2px 2px 5px 2px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  margin-left: 0;

  background-color: #000;

  > video {
    width: 100%;
    height: 100%;
  }
`;

export const Record = styled('div', { target: 'fb-photo-maker-record' })`
  width: 48px;
  height: 48px;
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 100%;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;

  &:before {
    content: '';
    position: absolute;
    top: 4px;
    left: 4px;
    width: 40px;
    height: 40px;
    border-radius: 100%;
    background-color: #fff;
    display: block;
  }

  &:not(.disabled):hover {
    &:before {
      width: 38px;
      height: 38px;
      top: calc(50% - 19px);
      left: calc(50% - 19px);
    }
  }

  &.movie {
    &:after {
      content: '';
      top: 4px;
      left: 4px;
      width: 40px;
      height: 40px;
      display: block;
      position: absolute;
      border-radius: 100%;
      background-color: red;
      transition: top 200ms, left 200ms, width 200ms, border-radius 300ms, height 200ms;
    }

    &:hover,
    &.recording {
      &:after {
        border-radius: 3px;
        top: calc(50% - 8px);
        left: calc(50% - 8px);
        width: 16px;
        height: 16px;
      }
    }
  }
`;

export const Option = styled.ul`
  margin: 0;
  padding: 0;
  display: flex;
  font-size: 14px;
  margin-bottom: 8px;
  list-style: none;
`;

export const CameraModeUI = styled('li', { target: 'fb-photo-maker-camera-mode-ui' })`
  cursor: pointer;
  padding-top: 8px;
  margin-right: 16px;
  position: relative;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.6);

  &:last-child {
    margin-right: 0;
  }

  &:before {
    content: '';
    height: 0px;
    width: 100%;
    background-color: #fff;
    position: absolute;
    margin: 0 auto;
    top: 0;
    left: 0%;
    opacity: 0;
    transition: height 150ms, opacity 150ms;
  }

  &.active {
    color: #fff;

    &:before {
      height: 2px;
      opacity: 1;
    }
  }
`;

export const BannerUI = styled.div<{small?: boolean}>`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  background: rgba(0, 0, 0, 0.3);
  height: ${({ small = false }) => (small ? '45px' : '100px')};

  &.disabled {
    opacity: 0.6;

    ${Record}, ${CameraModeUI} {
      cursor: not-allowed;
    }
  }
`;

export const AcceptMediaButton = styled(Button)`
  position: absolute;
  top: -20px;
  right: 16px;
  > span {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const Close = styled.span`
  position: absolute;
  top: 16px;
  left: 16px;
  color: rgba(255, 255, 255, 0.75);
  font-size: 24px;
  cursor: pointer;
  z-index: 1000;
  height: 16px;
  width: 16px;
  text-align: center;
  line-height: 16px;

  &:hover {
    color: #fff;
  }

  &:after {
    content: '×';
  }
`;

export const PreviewImage = styled.div<{src: string}>`
  background-image: url(${({ src }) => src});
  background-size: cover;
  width: 100%;
  height: 100%;
`;

export const TimerUI = styled(Flex)`
  gap: 4px;
  color: #fff;
  padding: 0 8px;
  margin-top: 8px;
  border-radius: 5px;
  margin-bottom: 8px;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.75);
`;

export const RecordDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  background-color: red;
  vertical-align: middle;
`;

export const ButtonSpacer = styled.div`
  width: 40px;
  flex-shrink: 0;
`;

export const PauseButton = styled(Button)`
  background-color: rgba(0, 0, 0, 0.5);
  border: none;
  color: #fff;
  height: 40px;

  &:hover,
  &:focus {
    border: none !important;
    background-color: rgba(0, 0, 0, 0.75) !important;
  }
`;
